/** @jsxImportSource @emotion/react */

import { Spin } from "antd";
import PaginationTable from "components/desktop/PaginationTable";
import { OrderType } from "enums/orders";
import { generateDateRange } from "helpers/generateDateRange";
import { ItemTransaction } from "pages/desktop/Transaction/ItemTransaction/ItemTransaction";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUsername } from "store/auth";
import { selectOrdersFilter, selectRebateOrders } from "store/orders";
import { getMemberRebateOrders } from "store/orders/orders.thunk";
import { AppDispatch } from "types";

import Nodata from "../Nodata";
import { RebateTableStyle } from "./style.index";
interface State {
  page: number;
}

const PAGE_SIZE = 7;
const RebateTable = () => {
  const dispatch = useDispatch<AppDispatch>();
  const filter = useSelector(selectOrdersFilter);

  const { data, isLoading, total } = useSelector(selectRebateOrders);

  const username =
    useSelector(selectUsername) || localStorage.getItem("username") || "";

  const [state, setState] = useState<State>({
    page: 1,
  });

  useEffect(() => {
    dispatch(
      getMemberRebateOrders({
        username: username,
        page: state.page,
        size: PAGE_SIZE,
        ...generateDateRange(filter),
      }),
    );
  }, [state.page, filter]);

  const renderList = () => {
    if (isLoading) {
      return (
        <div css={RebateTableStyle.loadingData}>
          {Array.from(Array(1), (_, index) => (
            <React.Fragment key={index}>
              <Spin />
              <span key={index}>Đọc dữ liệu...</span>
            </React.Fragment>
          ))}
        </div>
      );
    }
    if (!data?.length) {
      return <Nodata />;
    }

    return (
      <div>
        {data.map((item, index) => {
          return (
            <ItemTransaction
              key={`key-${index}-item-transaction`}
              title={item.create_date}
              createdDate={item.create_date}
              amount={item.amount}
              status={Number(item.status)}
              type={Number(item.type)}
              orderType={OrderType.REBATE}
            />
          );
        })}
      </div>
    );
  };

  return (
    <div css={RebateTableStyle.wrapper}>
      {renderList()}

      <PaginationTable
        lengthData={data?.length || 0}
        page={state.page}
        pageSize={PAGE_SIZE}
        total={total}
        onChangePage={(page: number) =>
          setState((prev) => ({
            ...prev,
            page,
          }))
        }
      />
    </div>
  );
};

export default RebateTable;
